export default {
  meta: {
    title: '车型详情',
    url: '/abside/mainmodels', // 埋点字段，上报归属的模块
    urlName: 'ab侧-车型详情', // 埋点字段，上报归属的模块
    logincallback: '/abside',
  }
};
